import { render, staticRenderFns } from "./azure.vue?vue&type=template&id=2434b40e&"
import script from "./azure.vue?vue&type=script&lang=js&"
export * from "./azure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports